module.exports = __webpack_public_path__ + "static/img/logo.e41f887.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/yyk/logo.svg
// module id = 946
// module chunks = 30